<script setup lang="ts">
import { RouterLink } from "vue-router";
</script>

<template>
  <main class="not-found-view">
    <p class="kicker">404 / Not Found</p>
    <h1>没有这个归档页面</h1>
    <p>链接可能已过期，或当前路径不属于公开查询产品。</p>
    <RouterLink class="tool-button" to="/">返回归档首页</RouterLink>
  </main>
</template>
